import { Link } from 'react-router-dom';
import { GalleryCrumb, galleryRoute } from '../../../lib/gallery/api';

export interface IGalleryBreadcrumbProps {
    crumbs: GalleryCrumb[];
}

export const GalleryBreadcrumb = ({ crumbs }: IGalleryBreadcrumbProps) => (
    <nav className="galeria__breadcrumb" aria-label="Ścieżka albumu">
        <ol>
            <li><Link to="/galeria">Galeria</Link></li>
            {crumbs.map((crumb, i) => (
                <li key={crumb.path}>
                    {i === crumbs.length - 1
                        ? <span aria-current="page">{crumb.name}</span>
                        : <Link to={galleryRoute(crumb.path)}>{crumb.name}</Link>}
                </li>
            ))}
        </ol>
    </nav>
);
